import { LocalStorageKeys } from 'app/shared/constants/localStorage';
import { LocalTableConfigType } from 'app/modules/localTableSettings/models';

export const LOCAL_TABLE_STORAGE_KEYS: Record<
  LocalTableConfigType,
  LocalStorageKeys
> = {
  [LocalTableConfigType.ASK_YOUR_ALERT_ACTION_EVENTS_TABLE]:
    LocalStorageKeys.AI_DATA_RAW_ACTION_EVENTS_TABLE_COLUMNS,
  [LocalTableConfigType.ASK_YOUR_ALERT_ENTITIES_TABLE]:
    LocalStorageKeys.AI_DATA_RAW_ENTITIES_TABLE_COLUMNS,
  [LocalTableConfigType.ASK_YOUR_ALERT_INSTRUMENTS_TABLE]:
    LocalStorageKeys.AI_DATA_RAW_INSTRUMENTS_TABLE_COLUMNS,
  [LocalTableConfigType.ASK_YOUR_ALERT_TXN_EVENTS_TABLE]:
    LocalStorageKeys.AI_DATA_RAW_TXN_EVENTS_TABLE_COLUMNS,
  [LocalTableConfigType.RULE_ADMIN_SCENARIO_CONFIG_TABLE]:
    LocalStorageKeys.RULE_ADMIN_SCENARIO_CONFIG_TABLE_COLUMNS,
  [LocalTableConfigType.RULE_ADMIN_CONTENT_TABLE]:
    LocalStorageKeys.RULE_ADMIN_CONTENT_TABLE_COLUMNS,
  [LocalTableConfigType.RULE_ADMIN_QUERY_TABLE]:
    LocalStorageKeys.RULE_ADMIN_QUERY_TABLE_COLUMNS,
  [LocalTableConfigType.RULE_ADMIN_EXECUTION_TABLE]:
    LocalStorageKeys.RULE_ADMIN_EXECUTION_TABLE_COLUMNS,
  [LocalTableConfigType.RULE_ADMIN_VALIDATION_TABLE]:
    LocalStorageKeys.RULE_ADMIN_VALIDATION_TABLE_COLUMNS,
  [LocalTableConfigType.RULE_ADMIN_SCHEDULE_TABLE]:
    LocalStorageKeys.RULE_ADMIN_SCHEDULE_TABLE_COLUMNS,
  [LocalTableConfigType.RULE_ADMIN_RISK_MODEL_EXECUTION_TABLE]:
    LocalStorageKeys.RULE_ADMIN_RISK_MODEL_EXECUTION_TABLE_COLUMNS,
  [LocalTableConfigType.RULE_ADMIN_RISK_MODEL_TABLE]:
    LocalStorageKeys.RULE_ADMIN_RISK_MODEL_TABLE_COLUMNS,
  [LocalTableConfigType.RULE_ADMIN_RISK_MODEL_CONFIG_TABLE]:
    LocalStorageKeys.RULE_ADMIN_RISK_MODEL_CONFIG_TABLE_COLUMNS,
  [LocalTableConfigType.RULE_ADMIN_ALERT_CONTENT_TABLE]:
    LocalStorageKeys.RULE_ADMIN_ALERT_CONTENT_TABLE_COLUMNS,
  [LocalTableConfigType.RULE_ADMIN_ALERT_HIT_TABLE]:
    LocalStorageKeys.RULE_ADMIN_ALERT_HIT_TABLE_COLUMNS,
  [LocalTableConfigType.DATA_SETTINGS_TABLE]:
    LocalStorageKeys.DATA_SETTINGS_TABLE_COLUMNS,
  [LocalTableConfigType.AI_ADMIN_TRACKING_TABLE]:
    LocalStorageKeys.AI_ADMIN_TRACKING_TABLE_COLUMNS,
};
